import Link from "next/link";
import Analytics from "@/lib/analytics";

type OutboundLinkProps = {
  children: React.ReactNode;
  className?: string;
  href: string;
  download?: boolean | string;
};

const OutboundLink = ({
  children,
  className,
  href,
  download,
}: OutboundLinkProps) => {
  const handleClick = () => {
    Analytics.handleOutboundClick(href);
  };

  return (
    <Link
      href={href}
      className={className}
      target="_blank"
      onClick={handleClick}
      download={download}
    >
      {children}
    </Link>
  );
};

export default OutboundLink;
